<input type="file" #emailList (change)="import($event.target.files)" accept=".csv"/>
<button class="btn bg-common btn-import" (click)="browseFile()">Import</button>
